import Framework, { BaseService } from '@greenville/framework';
import _ from 'lodash';
import * as constants from '../../../common/constants';
import utils from '../../../common/utils';

export default class PromptGetTypesService extends BaseService {
  constructor() {
    super(constants.GET_PROMPT_TYPES_DATA, 'PromptGetTypesStatus');
  }

  handleEvent(eventName, event) {
    let payload = {};
    const headers = {
      'x-berlin-tenant-id': event.payload.tenantId
    };
    payload = _.omit(event.payload, ['tenantId']);
    return this.getClient('evergreen').post(`/chatutility/admin/getTypes`, payload, { headers });
  }

  handleResponse(response) {
    const { data } = response;
    if (data.status === 'success') {
      // const notification = {
      //   open: true,
      //   type: 'success',
      //   message: 'Group Data Fetched successfully'
      // };
      // Framework.getStoreRegistry().getStore('notificationState').set(notification);
      Framework.getStoreRegistry().getStore('promptGetTypes').setResponse(response.data);
    }
  }

  handleError(error) {
    // eslint-disable-line class-methods-use-this
    const { response } = error;
    if (response) {
      const { status, data } = response;
      if (status === 401) {
        utils.redirectToLogin();
      }
      if (status === 500 && data && data.error) {
        const notification = {
          open: true,
          message: data.error.message,
          type: 'error'
        };
        Framework.getStoreRegistry().getStore('notificationState').set(notification);
      }
    } else if (error.message === 'timeout of 60000ms exceeded') {
      const notification = {
        open: true,
        message: error.message,
        type: 'error'
      };
      Framework.getStoreRegistry().getStore('notificationState').set(notification);
    }
  }
}
